import React from 'react';
import ReactDOM from 'react-dom/client';
import { OfficeProviders, type OfficeProvidersProps } from '~/pages/Office/Providers/OfficeProviders';

import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: OfficeProvidersProps;
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const data = (window as unknown as WindowWithData).data || {};

root.render(
  <React.StrictMode>
    <OfficeProviders {...data} />
  </React.StrictMode>
);